// src/Comman Components/Pinterest Componets/PinName.js

import React from 'react';
import { useSelector } from 'react-redux';

export default function PinName({ Id }) {
  const profileDetails = useSelector(state => state.groups.profileDetails[Id]);
  
  if (!profileDetails) return <span className='font-bold'>Loading...</span>;
  if (profileDetails.error) return <span className='font-bold text-yellow-600'>Profile Error</span>;

  const name = profileDetails.business_name || profileDetails.username || '...';

  return <span className='font-bold'>{name}</span>;
}